export default "__VITE_ASSET__CPyThdEr__"